<template>
  <div>
    <div class="wi-100x ht-100x pf lf-0 tp-0 z-1000" v-if="loading">
      <fo-loading @finishCallback="finishCallback"></fo-loading>
    </div>
    <div>
      <fo-navmenu
        :logoColor="logoColor"
        :iconColor="iconColor"
        :backColor="backColor"
        :textColor="textColor" />
      <fo-landing :loading="!loading"/>
      <fo-hotWorks />
      <fo-service :showTitle="showTitle" />
      <fo-hotPosts />
      <fo-clients />
      <fo-sayHello />
      <fo-bottom />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Home',
  computed: {
    ...mapGetters([
      'scrollTop',
      'scrollHeight',
      'screenWidth',
      'screenHeight',
      'refresh'
    ])
  },
  data () {
    return {
      loading: false,
      logoColor: '',
      textColor: '',
      backColor: '',
      iconColor: '',
      showTitle: false
    }
  },
  watch: {
    scrollTop () {
      this.setColor()
      this.setServiceTitle()
    },
    refresh (val) {
      if (val) {
        this.loading = true
      }
    }
  },
  mounted () {
    this.setColor()
    if (this.refresh) {
      this.loading = true
    }
  },
  methods: {
    finishCallback () {
      this.loading = false
      this.$store.commit('updateRefresh', false)
    },
    /*
    * 查询配置
    */
    readConfig () {
      this.get({
        url: 'webConfigsRead',
        data: {
          con_team_id: '6',
          page_size: 10,
          page_num: 1
        }
      }, (r) => {
        if (r.code) {
          r.data.items.map(item => {
            this.$.s(item.con_key, item.con_value)
          })
        }
      })
    },
    setServiceTitle () {
      var serviceHeight = document.getElementById('service-compos').offsetHeight
      var hotworksHeight = document.getElementById('hotworks-compos').offsetHeight
      if (this.scrollTop > hotworksHeight + this.screenHeight - 150 && this.scrollTop < hotworksHeight + this.screenHeight + serviceHeight - 150) {
        this.showTitle = true
      } else {
        this.showTitle = false
      }
    },
    setColor () {
      this.textColor = 'white'
      this.backColor = 'white-bg'
      this.iconColor = 'black-bg'
      this.logoColor = 'white'
      var appHeight = document.getElementById('app').offsetHeight
      var serviceHeight = document.getElementById('service-compos').offsetHeight
      var bottomHeight = document.getElementById('bottom-compos').offsetHeight
      let cond1 = this.scrollTop - this.screenHeight > 0
      let cond2 = this.scrollTop - this.screenHeight - 1334 < 0
      let cond3 = this.scrollTop - this.screenHeight - 1334 - serviceHeight > 0
      let cond4 = appHeight - appHeight * this.scrollHeight * 0.01 - bottomHeight + this.screenHeight < 0
      if ((cond1 && cond2) || (cond3 && !cond4)) {
        this.textColor = 'black'
        this.backColor = 'black-bg'
        this.iconColor = 'white-bg'
        this.logoColor = 'black'
      } else {
        this.textColor = 'white'
        this.backColor = 'white-bg'
        this.iconColor = 'black-bg'
        this.black = 'white'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue